import React from 'react';
import { MenuItem } from 'react-pro-sidebar';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { NavMenuItem } from '../../../domain/helpers/NavMenuItem';
import { useLanguageStore } from '../../../store/useLanguageStore';

interface ItemWithoutSubMenuProps {
    isCollapsed: boolean;
    selectedNav: string;
    navMenuItem: NavMenuItem;
    handleRedirect: (path: string) => void;
    setExpandedSubMenuId: React.Dispatch<React.SetStateAction<number | null>>;
    setExpandedSubMenuSettingId: React.Dispatch<React.SetStateAction<number | null>>;
}

export const ItemWithoutSubMenu: React.FC<ItemWithoutSubMenuProps> = ({
    isCollapsed, selectedNav, navMenuItem,
    handleRedirect, setExpandedSubMenuId, setExpandedSubMenuSettingId
}) => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();
    const isTextCentered = isCollapsed ? 'text-center' : '';
    const isItemCollapsed = isCollapsed ? `d-none` : '';

    const handleClick = () => {
        setExpandedSubMenuId(null);
        setExpandedSubMenuSettingId(null);
        handleRedirect(navMenuItem.route ?? '');
    }

    return <MenuItem
        key={navMenuItem.id}
        active={false}
        style={darkMode ? { color: 'white' } : {}}
        title={language[navMenuItem.name] || navMenuItem.name}
        className={`nav-bar-item ${isTextCentered}  ${selectedNav === navMenuItem.route ? darkMode ? 'active-nav-item-dark' : 'active-nav-item' : ''}`}
        onClick={handleClick}
    >
        {navMenuItem.icon}
        <span className={isItemCollapsed}>{language[navMenuItem.name]}</span>
    </MenuItem>
}
export default ItemWithoutSubMenu